import { motion, useReducedMotion } from "framer-motion";
import { Mail, Phone } from "lucide-react";

const EASE = [0.16, 1, 0.3, 1];

export const Contact = ({ onQuote }) => {
  const reduce = useReducedMotion();

  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="relative overflow-hidden bg-orange py-20 text-navy md:py-28"
    >
      <span
        aria-hidden="true"
        className="pointer-events-none absolute -right-8 top-0 select-none font-display text-[20vw] font-bold uppercase leading-none text-navy/5"
      >
        Call
      </span>

      <motion.div
        initial={reduce ? false : { opacity: 0, y: 32 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7, ease: EASE }}
        className="safe-x relative mx-auto max-w-7xl"
      >
        <p className="inline-flex items-center gap-3 font-display text-xs font-semibold uppercase tracking-[0.3em] text-navy/70">
          <span className="block h-[3px] w-8 bg-navy" aria-hidden="true" />
          Contact
        </p>
        <h2 className="mt-5 max-w-4xl font-display text-5xl font-bold uppercase leading-[0.95] sm:text-6xl lg:text-7xl">
          Got a crack? <br className="hidden sm:block" />
          Get it fixed.
        </h2>
        <p className="mt-6 max-w-xl text-base text-navy/75 md:text-lg">
          Call or email any time. If we&rsquo;re up a ladder, leave a message &mdash; we&rsquo;ll get
          back to you the same day.
        </p>

        <div className="mt-10 flex flex-col gap-4 sm:flex-row sm:flex-wrap">
          <a href="tel:0424424600" data-testid="contact-call-button" className="btn-navy">
            <Phone className="h-4 w-4" aria-hidden="true" />
            0424 424 600
          </a>
          <a
            href="mailto:admin@panereliefglass.com"
            data-testid="contact-email-button"
            className="btn-outline-navy"
          >
            <Mail className="h-4 w-4" aria-hidden="true" />
            admin@panereliefglass.com
          </a>
        </div>

        <button
          type="button"
          data-testid="contact-quote-button"
          onClick={onQuote}
          className="mt-8 font-display text-sm font-semibold uppercase tracking-[0.2em] text-navy underline decoration-2 underline-offset-8 transition-colors duration-200 hover:text-white"
        >
          Or send a quote request &rarr;
        </button>
      </motion.div>
    </section>
  );
};
